export function useFetchParagraphById(id: MaybeRef<number | undefined>) {
  const enabled = computed(() => Boolean(unref(id)));

  const paragraphQueries = queries().paragraphs;

  const query = useQuery({
    ...paragraphQueries.byId(id),
    enabled,
  });

  const queryClient = useQueryClient();

  whenever(query.data, (paragraph) => {
    queryClient.setQueryData(
      paragraphQueries.byId(paragraph.id).queryKey,
      paragraph
    );
  });

  return { query, enabled };
}
